import { render, staticRenderFns } from "./icon-github.vue?vue&type=template&id=30df49a0&"
import script from "./icon-github.vue?vue&type=script&lang=js&"
export * from "./icon-github.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports